export const BenchmarkSearchView = function (code) {
  this.code = code;
  this.benchmarkInput = document.getElementById("input_ric_search");
  this.benchmarkSelectDiv = document.getElementById("div_ric_search");
  this.benchmarkErrorDiv = document.getElementById("div_ric_search_error");

  var t = this;
  this.benchmarkInput.onkeyup = function (event) {
    t.search_ticker();
  };
};

BenchmarkSearchView.prototype.showBenchmarkError = function (error) {
  this.benchmarkErrorDiv.innerHTML = error;
  this.benchmarkErrorDiv.style.visibility = "visible";
  (function (t) {
    setTimeout(function () {
      t.benchmarkErrorDiv.style.visibility = "hidden";
    }, 3000);
  })(this);
};

BenchmarkSearchView.prototype.search_ticker = function () {
  var benchmark_input = this.benchmarkInput.value;
  if (benchmark_input == "") {
    this.benchmarkSelectDiv.style.display = "none";
    return;
  }

  var t = this;
  MST.testRic(benchmark_input, null, function (data) {
    t.search_ticker_continue(benchmark_input, data);
  });
};

BenchmarkSearchView.prototype.search_ticker_continue = function (
  benchmark_input,
  data
) {
  var objs = this.benchmarkSelectDiv.childNodes;
  for (var i = objs.length - 1; i >= 0; i--) {
    this.benchmarkSelectDiv.removeChild(objs[i]);
  }
  this.benchmarkSelectDiv.style.display = "none";
  if (data["items"].length == 0) {
    this.showBenchmarkError(
      "「" + benchmark_input + "」に該当するファンドが見つかりませんでした。"
    );
    return;
  } else {
    var ii = 0;
    for (var i = 0; i < data["items"].length; i++) {
      ii++;
      var li = document.createElement("div");
      li.className = "clearfix";
      this.benchmarkSelectDiv.appendChild(li);
      var span = document.createElement("span");
      span.innerHTML = data["items"][i]["name"];
      li.appendChild(span);

      (function (t, li, ric, name) {
        li.onclick = function () {
          t.add_ric(ric, name);
          t.benchmarkSelectDiv.style.display = "none";
        };
      })(this, li, data["items"][i]["ric"], data["items"][i]["name"]);
    }
    if (ii > 0) {
      this.benchmarkSelectDiv.style.display = "block";
    }
  }
};

BenchmarkSearchView.prototype.add_ric = function (benchmark, name) {
  let exist = false;
  document
    .querySelector("[data-fund-target='chartCompareModal']")
    .querySelectorAll("input[type='checkbox']")
    .forEach((checkbox) => {
      if (checkbox.value == benchmark) {
        exist = true;
      }
    });
  if (exist || benchmark == this.code) {
    this.benchmarkInput.value = "";
    this.showBenchmarkError("該当ファンドが既に表示されています");
    return;
  }

  this.addCheckbox(benchmark, name);

  this.benchmarkInput.value = "";
};

BenchmarkSearchView.prototype.addCheckbox = function (benchmark, name) {
  let c =
    '<li class="flex gap-3.5 items-start py-2.5 border-b border-itf-gray-placeholder">' +
    '<input type="checkbox" class="shrink-0 checkbox_style" id="' +
    benchmark +
    '" value="' +
    benchmark +
    '"/>' +
    "<label for='" +
    benchmark +
    "'>" +
    name +
    "</label>" +
    "<span class='delete_btn'></span></li>" +
    "</li>";
  document.querySelector(".chart_compare3").insertAdjacentHTML("beforeend", c);
  document
    .querySelector(".chart_compare3 li:last-child .delete_btn")
    .addEventListener("click", function (e) {
      e.target.parentNode.remove();
    });

  MST.lang["select"][benchmark] = name;
};
